import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import Button from '@v2/shared/components/Button';

type Props = {
  autoRenewServiceName: string;
  onDisable: () => void;
  loading?: boolean;
};

/**
 * The way out of every step of the disable flow: what disabling costs, and the button
 * that does it anyway.
 *
 * It sits at the foot of each step rather than being a step of its own, which is what
 * lets a customer who came to cancel cancel — without reading the survey or the offer —
 * while still being told once what it means.
 */
export default function CancelWarningBox({ autoRenewServiceName, onDisable, loading = false }: Props) {
  return (
    <div className="mt-6">
      <hr className="border-0 border-t border-solid border-gray-200 mb-6" />

      <h3 className="font-semibold text-lg mb-4 text-center">I Just Want to Disable {autoRenewServiceName}</h3>

      <div className="bg-red-50 border border-solid border-red-200 rounded-lg p-4">
        <div className="flex items-start mb-4">
          <FontAwesomeIcon icon={faExclamationTriangle} className="text-red-600 mr-2 mt-0.5" />
          <div className="text-red-800 text-sm">
            <span className="font-semibold">Warning:</span> Disabling {autoRenewServiceName} is permanent. You&apos;ll
            lose your discount and pay higher prices if you resubscribe.
          </div>
        </div>

        <div className="flex justify-center mt-4">
          <Button onClick={onDisable} className="text-sm" isLoading={loading} loadingText="Disabling...">
            <FontAwesomeIcon icon={faTrashAlt} className="mr-2" />
            Disable {autoRenewServiceName} Now
          </Button>
        </div>
      </div>
    </div>
  );
}
